import GraphContent from "../graph_content";
import { GraphSettingUpdateFunc } from "./update_graph_setting";
import { MstGraphType } from "../../../types/types";
import { getGraphSetting } from "./get_graph_setting";
import { getSensorData } from "./get_sensor_data";
import { reloadGraph } from "./reload_graph";
import MstGraphService from "../../../services/mst_graph_service";

const switchWait = (self: GraphContent) => {
  self.submitButton = false;
  self.submitWait = true;
};

const switchSuccess = (self: GraphContent) => {
  self.submitWait = false;
  self.submitComplete = true;
};

const switchDefault = (self: GraphContent) => {
  self.submitComplete = false;
  self.submitButton = true;
  self.submitWait = false;
};

const updateLocalData = (
  self: GraphContent,
  updatedData: GraphContent["mst_graph"]
) => {
  self.mst_graph = updatedData;
  self.dynamoRange = self.mst_graph.range;
  self.dynamoThreshold = self.mst_graph.threshold;
};

export async function saveGraphSetting(self: GraphContent) {
  try {
    if (self.timeFormat.toLowerCase() === "x") {
      self.orgTimeFormat = self.timeFormat;
    } else {
      self.orgTimeFormat = self.timeFormatToConfirm;
    }
    const updateData: MstGraphType = GraphSettingUpdateFunc.makeSendData(self);
    const validationMsg = GraphSettingUpdateFunc.checkUpdateData(updateData);
    if (typeof validationMsg === "string") {
      alert(validationMsg);
      return;
    }
    switchWait(self);
    let result;
    if (self.mst_graph === null) {
      result = await MstGraphService.create(updateData);
    } else {
      result = await MstGraphService.update(updateData);
    }
    switchSuccess(self);
    clearInterval(self.reloadEvent);
    await getGraphSetting(self);
    await getSensorData(self);
    if (self.reloadInterval > 0) {
      reloadGraph(self, self.reloadInterval);
    }
    updateLocalData(self, result);
    setTimeout(() => {
      switchDefault(self);
    }, 3000);
  } catch (e) {
    switchDefault(self);
    alert(self.$t("message.failedToSaveGraphSettings"));
    console.error(e);
  }
}
